import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
    current: null,
    currentLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get("sustainability/businessTargets", {
        params: {
          outcomes_id: payload.outcomes_id,
        },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("businessTargets/byID", { params: { id: id } });
      commit("setSelectedArticle", list.data);
      commit("setListLoading", false);
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("sustainability/businessTargets", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch(
        "businessTargets/loadAll",
        {
          outcomes_id: payload.outcomes_id,
        },
        { root: true }
      );
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
  },
};
